// extracted by mini-css-extract-plugin
export default {"burgeringredients":"BurgerIngredients_burgeringredients__ZDHVp","ingredientsitem":"BurgerIngredients_ingredientsitem__1GC7+","itemcontent":"BurgerIngredients_itemcontent__54+36"};